<template>
	<div>
		<div class="container_grid__outliers">
			<div class="container_grid__outliers_boxplot_space" />
			<div class="container_grid__outliers_boxplot_dap_ht">
				<Chart
					id="dispersao__parcelas"
					ref="ref__chart"
					style="width: 100%; min-height: 50vh; height: 100%"
					:options="chartOptions"
				/>
			</div>
			<div class="container_grid__outliers_boxplot_ht">
				<Chart
					id="dipersao__arvores__com__ht"
					ref="ref__chart__ht"
					style="width: 100%; min-height: 20vh; height: 100%"
					:options="chartOptionsBoxPlot"
				/>
			</div>
		</div>
		<CrudForm
			v-if="isVisible"
			:backdrop="true"
			:is-visible="true"
			:change-is-visible="closePanel"
		>
			<template #form>
				<div class="px-9 pt-9">
					<div class="mb-6">
						<h1 class="font-bold text-2xl text-[#272728]">
							{{ $t('editHistoricalBase') }}
						</h1>
						<!-- <p class="text-base text-[#272728] !m-0">{{ $t('instructionEditHistoricalBase') }}</p> -->
					</div>
					<div class="bg-[#CCD7DF] border border-[#272728] rounded p-4 gap-1 flex flex-col mb-8">
						<div class="flex justify-between">
							<p class="font-bold text-[#272728] !m-0">
								{{ $t('stratum') }}
							</p>
							<p class="font-bold text-[#272728] !m-0">
								{{ getValueByColumn('estrato') }}
							</p>
						</div>
						<div class="flex justify-between">
							<p class="font-bold text-[#272728] !m-0">
								{{ $t('section') }}
							</p>
							<p class="font-bold text-[#272728] !m-0">
								{{ getValueByColumn('talhao') }}
							</p>
						</div>
						<div class="flex justify-between">
							<p class="font-bold text-[#272728] !m-0">
								{{ $t('plot') }}
							</p>
							<p class="font-bold text-[#272728] !m-0">
								{{ getValueByColumn('parcela') }}
							</p>
						</div>
						<div class="flex justify-between">
							<p class="font-bold text-[#272728] !m-0">
								{{ $t('age') }}
							</p>
							<p class="font-bold text-[#272728] !m-0">
								{{ idade.toFixed(1) }}
							</p>
						</div>
						<div class="flex justify-between">
							<p class="font-bold text-[#272728] !m-0">
								{{ labelVariavel }}
							</p>
							<p class="font-bold text-[#272728] !m-0">
								{{ Number(model).toFixed(4) }}
							</p>
						</div>
					</div>
					<div class="flex flex-col gap-4">
						<InputText
							v-model="model"
							:label="labelVariavel"
						/>
						<InputText
							v-model.number="idade"
							:label="$t('age')"
						/>
					</div>
					<div class="flex gap-4 mt-8">
						<Button
							:label="`${$t('delete').toLowerCase()} ${$t('measurement').toLowerCase()}`"
							color="trv-error"
							outlined
							@click="deleteMeasurement"
						/>
						<Button
							:label="$t('save').toLowerCase()"
							:disabled="isDisabled"
							:loading="loading"
							@click="updateMeasurementValue"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script setup>
import { Chart } from 'highcharts-vue'
import { computed, ref, watch } from 'vue'
import i18n from '../../../VueI18n'
import Button from '../../../components/Button/Button.vue'
import CrudForm from '../../../components/CrudForm/CrudForm.vue'
import InputText from '../../../components/InputText/InputText.vue'
import { updateMedicao } from '../../../services/requests/DadosHistoricosRequests.js'
import { useDadosHistoricosStore } from '../../../store/modules/moduleDadosHistoricos.js'
import { useMessagesStore } from '../../../store/modules/moduleMessages'

const store = useDadosHistoricosStore()
const messagesStore = useMessagesStore()

const newValue = ref()
const newIdade = ref()
const medicaoId = ref(undefined)

watch(medicaoId, (value) => {
	if (!value) {
		newValue.value = undefined
	}
})

const loading = ref(false)

const labelVariavel = computed(() => {
	return store.getters.colunasProcessamento.find(
		(coluna) => coluna.key === store.state.variavelBiometrica,
	).label
})

const valueMedicaoSelecionada = computed(() => {
	const { key } = store.state.colunaAtributo.find(
		(coluna) => coluna.value === store.state.variavelBiometrica,
	)
	return medicaoSelecionada.value[key]
})

const idadeMedicaoSelecionada = computed(() => {
	const { key } = store.state.colunaAtributo.find((coluna) => coluna.value === 'idade')
	return medicaoSelecionada.value[key]
})

const model = computed({
	get: () => {
		return newValue.value || valueMedicaoSelecionada.value
	},
	set(value) {
		newValue.value = value
	},
})

const idade = computed({
	get: () => {
		return newIdade.value || idadeMedicaoSelecionada.value
	},
	set(value) {
		newIdade.value = value
	},
})

const medicaoSelecionada = computed(() => {
	return store.state.medicoesHistoricas.find((medicao) => medicao.id === medicaoId.value)
})

const baseHistoricaId = computed(() => {
	return window.location.search.split('=')[1]
})

const isVisible = computed(() => {
	return medicaoSelecionada.value != undefined
})

const isDisabled = computed(() => {
	return (
		valueMedicaoSelecionada.value === model.value &&
		!newValue.value &&
		(idadeMedicaoSelecionada.value === idade.value || !newIdade.value)
	)
})

function closePanel() {
	medicaoId.value = undefined
}

function updateMeasurementValue() {
	const { key } = store.state.colunaAtributo.find(
		(coluna) => coluna.value === store.state.variavelBiometrica,
	)
	const { key: key_idade } = store.state.colunaAtributo.find((coluna) => coluna.value === 'idade')

	if (newValue.value) {
		store.commit('changeRow', { id: medicaoId.value, key, value: newValue.value })
	}

	if (newIdade.value) {
		store.commit('changeRow', { id: medicaoId.value, key: key_idade, value: newIdade.value })
	}

	if (baseHistoricaId.value) {
		loading.value = true
		updateMedicao({
			...medicaoSelecionada.value,
			[key]: newValue.value || valueMedicaoSelecionada.value,
			[key_idade]: newIdade.value || idadeMedicaoSelecionada,
		})
			.then(() => {
				loading.value = false
				medicaoId.value = undefined
			})
			.catch(() => {
				loading.value = false
				medicaoId.value = undefined

				messagesStore.commit('mutationShowMessage', {
					messageTitle: i18n.t('error'),
					messageText: 'Erro ao realiza a atualização do registro',
					messageType: 'error',
				})
			})
	} else {
		medicaoId.value = undefined
	}
}

function deleteMeasurement() {
	store.commit('dropRow', medicaoId.value)
	medicaoId.value = undefined
}

function getValueByColumn(column) {
	const { key } = store.state.colunaAtributo.find((coluna) => coluna.value === column)
	return medicaoSelecionada.value[key]
}

function tooltip() {
	return (
		`<b>Idade: </b> ${this.point.x} meses<br/>` +
		`<b>${labelVariavel.value} </b> ${this.point.y} <br/>`
	)
}

const chartOptions = computed(() => {
	return {
		title: {
			text: '',
		},
		chart: {
			zoomType: 'xy',
		},
		tooltip: {
			formatter: tooltip,
		},
		xAxis: {
			title: {
				enabled: true,
				text: i18n.t('age'),
			},
		},
		legend: {
			enabled: false,
		},
		plotOptions: {
			series: {
				allowPointSelect: true,
				point: {
					events: {
						click: (e) => {
							medicaoId.value = e.point.id
						},
					},
				},
			},
		},
		yAxis: {
			min: 0,
			title: {
				enabled: true,
				text: labelVariavel.value,
			},
		},
		// turboThreshold: Number.MAX_SAFE_INTEGER,
		series: store.getters.seriesChart,
	}
})

const chartOptionsBoxPlot = computed(() => {
	return {
		chart: {
			type: 'boxplot',
		},
		legend: {
			enabled: false,
		},
		tooltip: {
			formatter: tooltip,
		},
		title: {
			text: '',
			enabled: false,
		},
		xAxis: {
			title: {
				text: 'Teste',
				style: {
					color: 'white',
				},
			},
			labels: {
				style: {
					color: 'white',
				},
			},
		},

		yAxis: {
			min: 0,
			title: {
				enabled: true,
				text: labelVariavel.value,
			},
			verticalAlign: 'top',
			startOnTick: true,
			endOnTick: true,
			showLastLabel: true,
			opposite: true,
		},
		turboThreshold: Number.MAX_SAFE_INTEGER,
		series: store.getters.seriesChartBoxPlot,
	}
})
</script>

<style>
/* @import url("../../../css/tooltipSimplesHighcharts.css"); */
.container_grid__outliers {
	display: grid;
	width: 100%;
	grid-template:
		'boxplot_dap boxplot_espaco'
		'boxplot_dap_ht  boxplot_ht';
	grid-template-columns: 7fr 1fr;
}

.container_grid__outliers_boxplot_dap {
	height: 10rem;
	grid-area: boxplot_dap;
}

.container_grid__outliers_boxplot_space {
	grid-area: boxplot_espaco;
}

.container_grid__outliers_boxplot_dap_ht {
	grid-area: boxplot_dap_ht;
}

.container_grid__outliers_boxplot_ht {
	grid-area: boxplot_ht;
}

/* @import url("../../css/tooltipSimplesHighcharts.css"); */
.container__grafico__dispersao {
	display: block;
	flex-direction: column;
	height: 100%;
}

.highcharts-container {
	margin: 0 !important;
	height: 100% !important;
}

.textoinformativo {
	color: rgb(149, 187, 73);
	text-align: center;
	vertical-align: bottom;
	font-weight: 800;
}

.tamanhoButton {
	width: 210px;
}

.divTexto {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

#dispersao__parcelas {
	height: 100%;
	max-height: 90%;
}
</style>
